import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  subDays,
} from 'date-fns';

export const getDefaultRanges = (date) => {
  const today = new Date();


  const customStartDate = subDays(today, 60);

  return [
    {
      label: 'This Week',
      startDate: startOfWeek(date),
      endDate: endOfWeek(date),
    },
    {
      label: 'This Month',
      startDate: startOfMonth(date),
      endDate: endOfMonth(date),
    },
    {
      label: 'Last 2 Months',
      startDate: customStartDate,
      endDate: today,
    },
    {
      label: 'Custom',
      startDate: null,
      endDate: null,
    },
  ];
};

export const defaultRanges = getDefaultRanges(new Date());
